// Gatsby requirements
import React from "react"
import { useStaticQuery, graphql } from 'gatsby'

// Components
import RichTextRenderer from './richTextRenderer'
import SeoStructuredData from './seoStructuredData'

// Styles
import * as CSS from './offers.module.scss'

const Offers = ({ offers, offerText, anchorId, backgroundColor, removeBottomMargin, removeTopMargin }) => {

    // Default offer text query
    const data = useStaticQuery(graphql`
        query {
            configuration: storyblokEntry(field_component: {eq: "Site Configuration"}) {
                content
            }
        }
    `)

    const defaultOfferText = JSON.parse(data.configuration.content)?.defaultOfferText;

    return (
        <section 
            className={`${CSS.section} ad-list-ratings`}
            id={anchorId ? anchorId : 'aanbiedingen'}
            style={{
                backgroundColor: backgroundColor ? backgroundColor : 'var(--background-color-alternative)',
                paddingTop: removeTopMargin ? '0' : null,
                paddingBottom: removeBottomMargin ? '1px' : null
            }}
        >

            <div className="wrapper">

                <div className={CSS.richtext}>
                    {offerText ?
                        <RichTextRenderer data={offerText} />
                        : 
                        <RichTextRenderer data={defaultOfferText} />
                    }
                </div>

                <ol className={`${CSS.adlist}`}>
                    {(offers.length > 1 && offers.every(o => o.rating)
                        ? [...offers].sort((a, b) => parseFloat(b.rating) - parseFloat(a.rating))
                        : offers
                    ).map((loop, index) => ( <>
                        {loop.structuredData && 
                            <SeoStructuredData data={loop.structuredData} />
                        }
                        <li 
                            className={CSS.card}
                            style={{
                                backgroundColor: 'var(--background-color)',
                            }}>

                            <span aria-hidden="true" className={CSS.number}>{index + 1}</span>

                            <div className={CSS.logoAndText}>
                                {loop.image.filename &&
                                    <div className={CSS.logoAndRatings}>
                                        <img
                                            src={loop.image.filename}
                                            loading="lazy"
                                            className={CSS.logo}
                                            width={loop?.image?.filename?.split('/')[5]?.split('x')[0]}
                                            height={loop?.image?.filename?.split('/')[5]?.split('x')[1]}
                                            alt={loop?.imageHeight}
                                            style={{maxHeight: loop?.imageHeight ? loop.imageHeight + 'px' : ''}}
                                        />
                                        {loop.rating &&
                                            <div className={CSS.rating}>
                                                <img
                                                    src="/icons/star-rating.svg"
                                                    className={`
                                                        ${CSS.starRating}
                                                        ${loop.rating > 8 && loop.rating <= 9 && CSS.rating45}
                                                        ${loop.rating > 7 && loop.rating <= 8 && CSS.rating4}
                                                        ${loop.rating > 6 && loop.rating <= 7 && CSS.rating35}
                                                        ${loop.rating > 5 && loop.rating <= 6 && CSS.rating3}
                                                        ${loop.rating > 4 && loop.rating <= 5 && CSS.rating25}
                                                        ${loop.rating > 3 && loop.rating <= 4 && CSS.rating2}
                                                        ${loop.rating > 2 && loop.rating <= 3 && CSS.rating15}
                                                        ${loop.rating <= 2 && CSS.rating1}
                                                    `}
                                                    loading="lazy"
                                                    width="106"
                                                    height="17"
                                                    alt={`Star rating: ${loop.rating.replace('.', ',')}`}
                                                />
                                                <span aria-hidden="true">{loop.rating.replace('.', ',')}</span>
                                            </div>
                                        }
                                    </div>
                                }

                                {loop.richtext &&
                                    <div className={CSS.firstText}>
                                        <RichTextRenderer data={loop.richtext} />
                                    </div>
                                }
                            </div>

                            {loop.secondRichtext &&
                                <div className={CSS.secondText}>
                                    <RichTextRenderer data={loop.secondRichtext} />
                                </div>
                            }
                        </li>
                    </> ))}
                </ol>

            </div>

        </section>
    )
}

export default Offers